import styles from './Modal.module.css';
import ReactDOM from 'react-dom';

type ModalProps = {
  children: any;
  open: boolean;
};
const Modal = (props: ModalProps) => {
  if (!props.open) return null;

  return ReactDOM.createPortal(
    <>
      <div className={styles.container}>
        <div className={styles.content}>{props.children}</div>
      </div>
    </>,
    document.getElementById('portal') as Element
  );
};

export default Modal;
